import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Collapse, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import { useEventTagContext } from "../../context/EventTagContext/EventTagContext";
import { EventTagItems } from "./constants";

const EditEventTag = () => {
	const { id } = useParams<{ id: string }>();
	const { updateEventTag, getEventTagDetails, clearEventTagFormData, eventTagDetail, operationStatus } = useEventTagContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getEventTagDetails(id);
		}

		return () => {
			clearEventTagFormData();
		};
	}, [id]);

	return (
		<>
			<BackComponent text="Etiket Listesine Dön" to="/event-tags" style={{ marginBottom: "24px" }} />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>Etiket Güncelleme</FormHeaderComponent>
						{eventTagDetail && (
							<Collapse
								items={EventTagItems}
								expandIconPosition="end"
								bordered={false}
								ghost
								expandIcon={CollapseExpandIcon}
								defaultActiveKey={["1"]}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateEventTag}
								type="default"
								disabled={!eventTagDetail}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>

		</>
	);
};

export default EditEventTag;
